import embeddedTypeFormTemplate from './embedded-type-form.tpl.html';
import './embedded-type-form.less';
import '../../../../../node_modules/@typeform/embed/build/embed-next';
import '../../../../../node_modules/@typeform/embed/build/css/widget.css';
import { landingTrackerServiceModule } from '../../services/landing-tracker-service';
import { tryFunctionHelperModule } from '../../../../shared/app/helpers/try-function';

export const embeddedTypeFormComponentModule = angular
  .module('Q.components.embedded-type-form', [
    landingTrackerServiceModule,
    tryFunctionHelperModule,
  ])

  .component('embeddedTypeForm', {
    bindings: {
      formId: '@',
      hiddenFields: '<',
      trackingParams: '<',
      hideFooter: '<',
      hideHeaders: '<',
      minHeight: '<',
      onReady: '&',
      onSubmit: '&',
      onQuestionChanged: '&',
      typeFormEvent: '@',
    },
    controller: 'EmbeddedTypeFormCtrl',
    template: embeddedTypeFormTemplate,
  })

  .controller(
    'EmbeddedTypeFormCtrl',
    function EmbeddedTypeFormCtrl(
      $element,
      $scope,
      $window,
      trackerService,
      tryFunction,
    ) {
      const ctrl = this;

      const track = tryFunction((action) => {
        if (ctrl.typeFormEvent) {
          trackerService.trackEvent(`${ctrl.typeFormEvent} ${action}`);
        }
      });

      ctrl.$onInit = () => {
        if (!$window.tf || !$window.tf.createWidget) {
          track('TypeForm Library not found');
          ctrl.error = 'form library not found';
          return;
        }
        track('Started');
        try {
          const $container = $element.querySelector(
            '.embedded-type-form-container',
          );
          if (ctrl.minHeight) {
            $container.css({ 'min-height': ctrl.minHeight + 'px' });
          }
          $window.tf.createWidget(ctrl.formId, {
            container: $container[0],
            hidden: ctrl.hiddenFields || {},
            tracking: ctrl.trackingParams || {},
            hideFooter: !!ctrl.hideFooter,
            hideHeaders: !!ctrl.hideHeaders,
            opacity: 0,
            onReady() {
              $scope.$applyAsync(() => {
                track('Ready');
                ctrl.onReady();
              });
            },
            onSubmit(event) {
              $scope.$applyAsync(() => {
                track('Submitted');
                ctrl.onSubmit({ event });
              });
            },
            onQuestionChanged(event) {
              $scope.$applyAsync(() => {
                ctrl.onQuestionChanged({ event });
              });
            },
            autoResize: `${ctrl.minHeight || 200},1200`,
            inlineOnMobile: true,
          });
        } catch (err) {
          track('Error with TypeForm: ' + err);
          ctrl.error = err;
        }
      };
    },
  );
